<template>
  <v-container fluid grid-list-md style="padding:10px 10px 5px 10px; width:100%; height:100%;" class="filters">
    <v-layout column>
      <v-flex>
        <v-card>
          <v-card-title primary class="title" style="height:5%;width:100%;padding-top:5px;padding-bottom:5px;">Filters</v-card-title>
          <v-card-actions fill-height style="height:95%; width:100%; padding-top:8px; padding-bottom:8px; align-items:flex-start; overflow:auto; display: block;">
            <v-layout row v-for="field in filterFields" :key="field" style="width: 100%; margin: 0; padding: 0;">
              <v-flex v-if="field.options.length > 1" style="padding-top: 1rem; padding-bottom: 1rem">
                <v-layout column>
                  <v-layout row>
                    <v-autocomplete v-model="models[field.title]" name="" id="" :items="field.options" multiple :label="field.title" @change="listChanged(field.title)" clearable="true">
                    </v-autocomplete>
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex v-else-if="field.options.length == 1" style="padding-top: 1rem; padding-bottom: 2rem; height: 32px">
                <v-layout column>
                  <v-layout row>
                    <v-layout column style="margin-left: 0; margin-top: 4px; font-size: 16px;">
                      {{ field.title }}
                    </v-layout>
                    <v-layout column style="margin-top: 3px;">
                      <v-switch @change="switchChanged(field.title,field.options[0])"></v-switch>
                    </v-layout>
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex v-else style="padding-top: 1rem; padding-bottom: 2rem;">
                <v-layout column>
                  <v-layout row style="font-size: 16px;">
                    {{ field.title }}
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <v-card-title primary class="title" style="height:5%;width:100%; padding-right:5px; padding-top:5px;padding-bottom:5px;">Engine Types</v-card-title>
          <v-card-actions fill-height style="height:95%;width:100%;padding-top:0px;padding-bottom:0px;">
            <dx-data-grid class="grid" :data-source="customerGridFiltered" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true" @cellClick="gridClick" @cellPrepared="cellPrepared">
              <dx-column data-field="name" caption="Customer"/>
              <dx-column data-field="tickets" cell-template="ticketTemplate" caption="Open Tickets" alignment="left"/>
              <dx-column data-field="status"/>
              <dx-column data-field="engines" cell-template="enginesTemplate"/>
              <div slot="favTemplate" slot-scope="{ data }" style="display:flex;justify-content:center;align-items:center;">
                <img src="../assets/favorite.png" v-if="data.value">
              </div>
              <div slot="ticketTemplate" slot-scope="{ data }" style="display:flex;align-items:left;">
                <img src="../assets/ticket_dark.png" style="height:20px;width:20px;">
                <div style="padding-left:15px;width:100%;height:100%;font-size:14px;">{{ data.value }}</div>
              </div>
              <div slot="enginesTemplate" slot-scope="{ data }" style="display:flex;align-items:center;max-width: 100px;">
                <v-layout column v-if="typeof data.value != 'undefined' && data.value.length" style="padding: 5px 0;">
                  <div class="slides" style="" v-on:scroll="onSlideScroll">
                    <div v-for="eng in data.value" :key="eng" class="slide">
                      <v-layout row style="max-width: 100px">
                        <img v-if="eng.color=='green'" src="../assets/colordotsgray.png" style="height:10px;width:10px;margin:5px;">
                        <img v-else-if="eng.color=='yellow'" src="../assets/colordotsorange.png" style="height:10px;width:10px;margin:5px;">
                        <img v-else src="../assets/colordotsred.png" style="height:20px;width:20px;margin:5px;">
                        <v-layout column>
                          <v-flex d-flex md6>{{ eng.engine }}</v-flex>
                          <v-flex d-flex md6>{{ eng.vessel }}</v-flex>
                        </v-layout>
                      </v-layout>
                    </div>
                  </div>
                  <v-layout row v-if="data.value.length > 1" style="padding-top: 5px;">
                    <div style="width: 50%; text-align: center;">
                      <a class="slider-arrows scroll-back disabled" href="#" @click="slideBackward">
                        <i class="material-icons">chevron_left</i>
                      </a>
                    </div>
                    <div style="width: 50%; text-align: center;">
                      <a class="slider-arrows scroll-forward" href="#" @click="slideForward">
                        <i class="material-icons">chevron_right</i>
                      </a>
                    </div>
                  </v-layout>
                </v-layout>
              </div>
            </dx-data-grid>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';
import axios from 'axios';
import {store} from "../main.js";

export default {
  name: "CustomersOverview",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling
  },
  data() {
    return {
      filterFields: [],
      models: {},
      customerGridFiltered: [],
      customerGridAll: [],
      appliedFilters: {
        'Control System': [],
        'Fuel Type': [],
        'Engine Type': [],
        'Open Tickets': [],
        'Engine KPI': [],
      },
      filterEnabled: {}
    }
  },
  props: {
    customersData: Array,
    active: Boolean
  },
  computed: {},
  created() {
    axios.post(store.config.api_location + '/GetCustomerFilters/').then(
        (response) => {
          if (response.status === 200) {
            this.filterFields = response.data.data;
          }
        },
        (error) => {
        }
    );
  },
  mounted() {
    setTimeout(() => {
      this.setData();
    });
  },
  methods: {
    gridClick(e) {
      if ((e.column.dataField == "name") && (e.rowType != "header")) {
        this.$router.push({path: `/customers/${e.value}`});
      }
    },
    cellPrepared(e) {
      if ((e.column.dataField == "name") && (e.rowType != "header")) {
        e.cellElement.classList.add('clickable');
      }
    },
    filter() {
      var filters = this.appliedFilters,
          filterCount = Object.keys(filters).reduce(function (r, k) {
            return r.concat(filters[k]);
          }, []);

      if (filterCount.length < 1) {
        this.customerGridFiltered = this.customerGridAll;

        for (var j in this.filterEnabled) {
          if (Object.prototype.hasOwnProperty.call(this.filterEnabled, j)) {
            this.filterEnabled[j] = false;
          }
        }
      } else {
        let tmpFiltered = this.customerGridAll;

        for (var i in this.appliedFilters) {
          if (Object.prototype.hasOwnProperty.call(this.appliedFilters, i)) {
            if (this.appliedFilters[i].length) {
              this.filterEnabled[i] = true;

              var filterValues = this.appliedFilters[i],
                  filterResult = [];


              switch (i) {
                case 'Open Tickets':
                  filterResult = tmpFiltered.filter(function (item) {
                    return item.tickets > 0;
                  });
                  break;
                default:
                  for (let j = 0; j < filterValues.length; j++) {
                    var tmpEng;

                    filterResult = filterResult.concat(tmpFiltered.filter(function (item) {
                      switch (i) {
                        case 'Control System':
                          tmpEng = item.engines.map(function (eng) {
                            return eng.controlSystem;
                          });
                          break;
                        case 'Fuel Type':
                          tmpEng = item.engines.map(function (eng) {
                            return eng.fuelType;
                          });
                          break;
                        case 'Engine Type':
                          tmpEng = item.engines.map(function (eng) {
                            return eng.engine;
                          });
                          break;
                      }

                      return tmpEng.includes(filterValues[j]);
                    }));
                  }
              }

              tmpFiltered = filterResult;
              this.customerGridFiltered = tmpFiltered;
            } else {
              this.filterEnabled[i] = false;
            }
          }
        }
      }
    },
    setData() {
      store.selectedTicketsVessel = '';

      let companies = Object.keys(this.customersData);

      this.customerGridAll = [];
      for (let i = 0; i < companies.length; i++) {
        let customer = {
          name: companies[i],
          status: this.customersData[companies[i]].status,
          engines: [],
          tickets: 0,
          favorite: false,
        };

        let vessels = Object.keys(this.customersData[companies[i]].vessels);

        for (let j = 0; j < vessels.length; j++) {
          let vessName = vessels[j],
              engType = this.customersData[companies[i]].vessels[vessName].engineType,
              engines = Object.keys(this.customersData[companies[i]].vessels[vessName].engines);

          for (let e = 0; e < engines.length; e++) {
            let kpiClr = Number(this.customersData[companies[i]].vessels[vessName].engines[engines[e]].eng_KPI_color),
                clr;

            if (kpiClr == 0)
              clr = 'green';
            else if (kpiClr == 10)
              clr = 'yellow';
            else
              clr = 'red';

            customer.engines.push({
              engine: engType,
              vessel: vessName,
              color: clr,
              controlSystem: store.engineAggr[engType]['controlSystem'],
              fuelType: store.engineAggr[engType]['fuelType']
            });

            customer.tickets += store.vesselTickets[vessName].open.length;
          }
        }

        this.customerGridAll.push(customer);
      }

      this.customerGridFiltered = this.customerGridAll;
      this.filter();
    },
    slideBackward(event) {
      var slider = event.target.offsetParent.querySelectorAll('.slides')[0],
          slide = slider.querySelectorAll('.slide')[0];

      slider.scrollLeft -= slide.getBoundingClientRect().width;
    },
    slideForward(event) {
      var slider = event.target.offsetParent.querySelectorAll('.slides')[0],
          slide = slider.querySelectorAll('.slide')[0];

      slider.scrollLeft += slide.getBoundingClientRect().width;
    },
    onSlideScroll(event) {
      var slider = event.target,
          slides = slider.querySelectorAll('.slide'),
          scroll_back = event.target.offsetParent.querySelector('.scroll-back'),
          scroll_forward = event.target.offsetParent.querySelector('.scroll-forward');

      scroll_back.classList.remove('disabled');
      scroll_forward.classList.remove('disabled');

      if (slider.scrollLeft == 0) {
        scroll_back.classList.add('disabled');
      } else if (slider.scrollLeft >= (slider.clientWidth * (slides.length - 1))) {
        scroll_forward.classList.add('disabled');
      }
    },
    switchChanged(group, value) {
      if (this.appliedFilters[group].length < 1) {
        this.appliedFilters[group] = [value];
      } else {
        this.appliedFilters[group] = [];
      }

      this.filter();
    },
    listChanged(group) {
      var filters = [];

      for (var i in this.models[group]) {
        filters.push(this.models[group][i]);
      }

      this.appliedFilters[group] = filters;
      this.filter();
    }
  },
  watch: {
    customersData: function () {
      setTimeout(() => {
        this.setData();
      });
    }
  }
}
</script>

<style scoped>
.grid {
  font-size: 12px;
}

.slides {
  display: -webkit-box;
  display: flex;

  overflow-x: auto;
  -ms-scroll-snap-type: x mandatory;
  scroll-snap-type: x mandatory;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  height: 70px;
}

.slides > div {
  width: 100%;
  scroll-snap-align: start;
  flex-shrink: 0;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
  position: relative;

  display: -webkit-box;

  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

.slider-arrows.disabled {
  color: lightgray;
}
</style>


<style>
.filters .v-input, .filters .v-input__slot, .filters .v-input--selection-controls__input {
  margin: 0 !important;
  padding: 0 !important;
}

.filters .v-input--switch {
  width: fit-content;
  position: relative;
  left: calc(100% - 44px);
}

.filters .v-label:not(.v-label--active) {
  color: black;
}
</style>